import { FC } from 'react';

import Heading from '@/components/elements/Heading';
import Text from '@/components/elements/Text';

export interface PullquoteProps {
  uid: any;
  quote: any;
  name: any;
  position: any;
}

const Pullquote: FC<PullquoteProps> = ({ uid, quote, name, position }) => {
  return (
    <div
      key={uid}
      className="not-prose relative mx-auto w-full max-w-7xl py-4 md:py-8"
    >
      <div className="relative w-full lg:flex lg:items-center">
        <div className="relative">
          <blockquote className="relative !mx-0 w-full border-0 !px-0 text-center not-italic">
            <Heading
              size="md"
              color="black"
              className="!max-w-none font-display"
            >
              {quote}
            </Heading>
            {name ||
              (position && (
                <footer className="mt-8 flex flex-col gap-1">
                  <Text
                    size="xl"
                    color="dark"
                    element="span"
                    className="font-medium"
                  >
                    {name}
                  </Text>
                  <Text element="span" color="primary">
                    {position}
                  </Text>
                </footer>
              ))}
          </blockquote>
        </div>
      </div>
    </div>
  );
};

export default Pullquote;
